import { Theme } from "@material-ui/core/styles";
//import debugTheme from "themes/theme-debug";
import theme from "../theme";

function getTheme(): Theme {
  return theme;
}

export { getTheme };
